/* Coming-Soon-Drops — Countdown + Klaviyo Notify-Me
   <coming-soon-drops data-launch-epoch="1756742400"
                      data-klaviyo-key="..." data-klaviyo-list="..." data-drop-handle="..."> */
if (!customElements.get('coming-soon-drops')) {
  class ComingSoonDrops extends HTMLElement {
    connectedCallback() {
      this.launchMs = Number(this.dataset.launchEpoch || 0) * 1000;
      this.nums = {
        days: this.querySelector('[data-cd-days]'),
        hours: this.querySelector('[data-cd-hours]'),
        minutes: this.querySelector('[data-cd-minutes]'),
        seconds: this.querySelector('[data-cd-seconds]'),
      };
      this.slider = this.querySelector('[data-slider]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      if (this.slider && this.prevBtn && this.nextBtn) this.initSlider();

      if (this.launchMs > 0 && !this.classList.contains('csd--live')) {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      const diff = this.launchMs - Date.now();
      if (diff <= 0) {
        this.goLive();
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      this.setNum('days', Math.floor(totalSeconds / 86400));
      this.setNum('hours', Math.floor((totalSeconds % 86400) / 3600));
      this.setNum('minutes', Math.floor((totalSeconds % 3600) / 60));
      this.setNum('seconds', totalSeconds % 60);
    }

    setNum(key, value) {
      if (this.nums[key]) this.nums[key].textContent = String(value).padStart(2, '0');
    }

    /* Unendlich-Slider: Items werden 3x gerendert (Original + 2 Klone) und der
       Slider startet in der mittleren Kopie — dadurch ist ab dem Start in
       beide Richtungen Platz. Nach jedem Scroll-Ende wird die Position
       unsichtbar um exakt eine Set-Breite zurück in die Mitte verschoben.
       Die Fortschritts-Bar zeigt die Position innerhalb EINES Sets (modulo):
       beim Wrap springt der Balken ans andere Ende. */
    initSlider() {
      this.progress = this.querySelector('[data-slider-progress]');
      this.thumb = this.querySelector('[data-slider-thumb]');
      this.thumbWrap = this.querySelector('[data-slider-thumb-wrap]');
      if (this.slider.scrollWidth - this.slider.clientWidth < 4) {
        this.prevBtn.hidden = true;
        this.nextBtn.hidden = true;
        if (this.progress) this.progress.hidden = true;
        // CSS/Bilder evtl. noch nicht fertig geladen — nach window.load erneut messen
        if (!this.retriedInit && document.readyState !== 'complete') {
          this.retriedInit = true;
          window.addEventListener('load', () => this.initSlider(), { once: true });
        }
        return;
      }
      this.prevBtn.hidden = false;
      this.nextBtn.hidden = false;
      if (this.progress) this.progress.hidden = false;
      const items = Array.from(this.slider.children);
      this.originalCount = items.length;
      for (let copy = 0; copy < 2; copy += 1) {
        items.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
          this.slider.appendChild(clone);
        });
      }
      this.prevBtn.addEventListener('click', () => this.scrollSlider(-1));
      this.nextBtn.addEventListener('click', () => this.scrollSlider(1));
      this.measure();
      this.slider.addEventListener(
        'scroll',
        () => {
          // Alles im Animation-Frame bündeln — keine Layout-Reads im Scroll-Handler (Jank!)
          if (!this.rafPending) {
            this.rafPending = true;
            requestAnimationFrame(() => {
              this.rafPending = false;
              this.guardBounds();
              this.updateProgress();
            });
          }
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.normalizeScroll(), 120);
        },
        { passive: true }
      );
      this.slider.addEventListener('scrollend', () => this.normalizeScroll(), { passive: true });
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.measure();
          this.updateProgress();
        }, 150);
      }, { passive: true });
      window.addEventListener('load', () => {
        this.measure();
        this.updateProgress();
      }, { once: true });
      this.slider.scrollTo({ left: this.originalCount * this.sliderStep(), behavior: 'instant' });
      this.updateProgress();
    }

    updateProgress() {
      if (!this.progress || !this.thumb) return;
      const setWidth = this.originalCount * this.sliderStep();
      if (setWidth <= 0) return;
      const fraction = ((this.slider.scrollLeft % setWidth) + setWidth) % setWidth / setWidth;
      // Zyklisch + smooth: Balken wandert 1:1 mit dem Scroll durch das Set.
      // Läuft er rechts über die Leiste hinaus, erscheint der Überstand
      // gleichzeitig links (zweites Segment) — kein Sprung an der Naht.
      const thumbPercent = Math.max(100 / this.originalCount, 10);
      let left = fraction * 100;
      // Subpixel-Drift am Start-/Endpunkt auf exakt 0 schnappen
      if (left < 1 || left > 99) left = 0;
      const overflow = left + thumbPercent - 100;
      this.thumb.style.width = `${Math.min(thumbPercent, 100 - left)}%`;
      this.thumb.style.left = `${left}%`;
      if (this.thumbWrap) {
        if (overflow > 0) {
          this.thumbWrap.style.display = 'block';
          this.thumbWrap.style.left = '0%';
          this.thumbWrap.style.width = `${overflow}%`;
        } else {
          this.thumbWrap.style.display = 'none';
        }
      }
    }

    /* Kartenbreite + Gap einmalig messen (Init/Resize/Load) — NICHT pro Scroll-Event */
    measure() {
      const card = this.slider.querySelector('li');
      if (!card) {
        this.step = 0;
        return;
      }
      const gap = parseFloat(getComputedStyle(this.slider).columnGap) || 16;
      this.step = card.getBoundingClientRect().width + gap;
    }

    sliderStep() {
      return this.step || 0;
    }

    scrollSlider(direction) {
      const step = this.sliderStep() || this.slider.clientWidth * 0.8;
      this.slider.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    normalizeScroll() {
      const setWidth = this.originalCount * this.sliderStep();
      if (setWidth <= 0) return;
      const position = this.slider.scrollLeft;
      if (position < setWidth * 0.5) {
        this.slider.scrollTo({ left: position + setWidth, behavior: 'instant' });
      } else if (position >= setWidth * 1.5) {
        this.slider.scrollTo({ left: position - setWidth, behavior: 'instant' });
      }
    }

    /* Sofort-Teleport bei schnellem Durchscrollen (siehe infinity-slider.js) */
    guardBounds() {
      const setWidth = this.originalCount * this.sliderStep();
      if (setWidth <= 0) return;
      const position = this.slider.scrollLeft;
      if (position < setWidth * 0.25) {
        this.slider.scrollTo({ left: position + setWidth, behavior: 'instant' });
      } else if (position >= setWidth * 1.75) {
        this.slider.scrollTo({ left: position - setWidth, behavior: 'instant' });
      }
    }

    goLive() {
      if (this.timer) clearInterval(this.timer);
      this.classList.add('csd--live');
      this.querySelectorAll('[data-live-href]').forEach((el) => {
        el.setAttribute('href', el.dataset.liveHref);
      });
    }

  }
  customElements.define('coming-soon-drops', ComingSoonDrops);
}

/* <drop-notify-form> — Klaviyo Drop-Benachrichtigung (E-Mail-Signup).
   Eigenständiges Element, genutzt in der Coming-Soon-Section und in
   main-product (ersetzt dort den Warenkorb-Button bei aktivem Drop).
   <drop-notify-form data-klaviyo-key="..." data-klaviyo-list="..." data-drop-handle="...">
     <form data-notify-form> E-Mail-Input + Submit + Erfolgs-/Fehlermeldung </form>
   </drop-notify-form> */
if (!customElements.get('drop-notify-form')) {
  class DropNotifyForm extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.querySelector('[data-notify-form]');
      if (!this.form) return;
      this.bound = true;
      this.form.addEventListener('submit', this.onSubmit.bind(this));

      // Optionales Popup: Trigger-Button öffnet <dialog> mit dem Formular
      this.dialog = this.querySelector('[data-notify-dialog]');
      const opener = this.querySelector('[data-notify-open]');
      if (this.dialog && opener) {
        opener.addEventListener('click', () => {
          this.dialog.showModal();
          document.body.classList.add('overflow-hidden');
          this.dialog.querySelector('input[type="email"]')?.focus();
        });
        this.querySelectorAll('[data-notify-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.dialog.close());
        });
        // Klick auf den Backdrop schließt
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        // 'close' feuert auch bei ESC — Scroll-Lock immer sauber aufheben
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('overflow-hidden');
        });
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const input = this.form.querySelector('input[type="email"]');
      const button = this.form.querySelector('button');
      const email = (input.value || '').trim();
      this.classList.remove('is-error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.classList.add('is-error');
        return;
      }
      button.disabled = true;
      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.klaviyoKey)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Coming Soon Drop',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        properties: { coming_soon_drop: this.dataset.dropHandle || '' },
                      },
                    },
                  },
                },
                relationships: {
                  list: { data: { type: 'list', id: this.dataset.klaviyoList } },
                },
              },
            }),
          }
        );
        if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
        this.classList.add('is-success');
      } catch (error) {
        this.classList.add('is-error');
      } finally {
        button.disabled = false;
      }
    }
  }
  customElements.define('drop-notify-form', DropNotifyForm);
}
